import { StringSchema } from 'yup';
import { onlyNumbers } from '~constants/regularExpressions';

const defaultMessage = 'Campo incompleto';

export default function zipCode(
  this: StringSchema,
  message: string = defaultMessage
) {
  return this.test('zipCode', message, (value) => {
    const zipCode = value?.replace(onlyNumbers, '');

    const schema = this.min(8, defaultMessage);

    return schema.isValidSync(zipCode);
  });
}
